module.exports = __webpack_public_path__ + "static/video-1-1-49ab78fad693fccc825876f59ee29b34.jpg";